import React from 'react';
import { Link } from 'react-router-dom';
import { PhoneIcon, MailIcon, MapPinIcon, FacebookIcon, InstagramIcon, LinkedinIcon } from 'lucide-react';
const Footer = () => {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-[#1e2a1e] text-gray-300" data-id="element-24">
      <div className="container mx-auto px-4 py-12 md:py-16" data-id="element-25">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-26">
          {/* Company Info */}
          <div data-id="element-27">
            <div className="mb-4" data-id="element-28">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/jNgbQRnLDdHb3eLey3g2BG/s___r_logo-removebg-preview-1.png" alt="Socrates and Richard Logo" className="h-16" data-id="element-29" />
            </div>
            <p className="mb-4" data-id="element-30">
              Building Futures, Real Estate, & Investment Solutions
            </p>
            <div className="flex space-x-4" data-id="element-31">
              <a href="https://facebook.com" className="text-gray-400 hover:text-[#95c11f] transition-colors" aria-label="Facebook" data-id="element-32">
                <FacebookIcon size={20} data-id="element-33" />
              </a>
              <a href="https://instagram.com" className="text-gray-400 hover:text-[#95c11f] transition-colors" aria-label="Instagram" data-id="element-34">
                <InstagramIcon size={20} data-id="element-35" />
              </a>
              <a href="https://linkedin.com" className="text-gray-400 hover:text-[#95c11f] transition-colors" aria-label="LinkedIn" data-id="element-36">
                <LinkedinIcon size={20} data-id="element-37" />
              </a>
            </div>
          </div>
          {/* Quick Links */}
          <div data-id="element-38">
            <h3 className="text-lg font-semibold text-white mb-4" data-id="element-39">
              Quick Links
            </h3>
            <ul className="space-y-2" data-id="element-40">
              <li data-id="element-41">
                <Link to="/" className="hover:text-[#95c11f] transition-colors" data-id="element-42">
                  Home
                </Link>
              </li>
              <li data-id="element-43">
                <Link to="/about" className="hover:text-[#95c11f] transition-colors" data-id="element-44">
                  About Us
                </Link>
              </li>
              <li data-id="element-45">
                <Link to="/services" className="hover:text-[#95c11f] transition-colors" data-id="element-46">
                  Our Services
                </Link>
              </li>
              <li data-id="element-47">
                <Link to="/projects" className="hover:text-[#95c11f] transition-colors" data-id="element-48">
                  Projects
                </Link>
              </li>
              <li data-id="element-49">
                <Link to="/contact" className="hover:text-[#95c11f] transition-colors" data-id="element-50">
                  Contact
                </Link>
              </li>
            </ul>
          </div>
          {/* Services */}
          <div data-id="element-51">
            <h3 className="text-lg font-semibold text-white mb-4" data-id="element-52">
              Our Services
            </h3>
            <ul className="space-y-2" data-id="element-53">
              <li data-id="element-54">
                <Link to="/services" className="hover:text-[#95c11f] transition-colors" data-id="element-55">
                  Construction & Civil Works
                </Link>
              </li>
              <li data-id="element-56">
                <Link to="/services" className="hover:text-[#95c11f] transition-colors" data-id="element-57">
                  Water Engineering & Borehole
                </Link>
              </li>
              <li data-id="element-58">
                <Link to="/services" className="hover:text-[#95c11f] transition-colors" data-id="element-59">
                  Aluminum Fabrication
                </Link>
              </li>
              <li data-id="element-60">
                <Link to="/services" className="hover:text-[#95c11f] transition-colors" data-id="element-61">
                  Trading & General Supplies
                </Link>
              </li>
              <li data-id="element-62">
                <Link to="/services" className="hover:text-[#95c11f] transition-colors" data-id="element-63">
                  Manufacturing & Processing
                </Link>
              </li>
            </ul>
          </div>
          {/* Contact Info */}
          <div data-id="element-64">
            <h3 className="text-lg font-semibold text-white mb-4" data-id="element-65">
              Contact Us
            </h3>
            <ul className="space-y-3" data-id="element-66">
              <li className="flex items-start" data-id="element-67">
                <MapPinIcon size={18} className="mr-2 mt-1 flex-shrink-0 text-[#95c11f]" data-id="element-68" />
                <span data-id="element-69">
                  <strong data-id="element-70">Abuja Office:</strong>
                  <br data-id="element-71" />
                  12D Sherri Hills Crescent,
                  <br data-id="element-72" />
                  Hall 7, Imperial Vista Estate,
                  <br data-id="element-73" />
                  Kafe district, Life camp, Abuja.
                </span>
              </li>
              <li className="flex items-start" data-id="element-74">
                <MapPinIcon size={18} className="mr-2 mt-1 flex-shrink-0 text-[#95c11f]" data-id="element-75" />
                <span data-id="element-76">
                  <strong data-id="element-77">Benin Office:</strong>
                  <br data-id="element-78" />
                  11, Airiofolo avenue, off Irhirhi,
                  <br data-id="element-79" />
                  Off Airport road, Benin City.
                </span>
              </li>
              <li className="flex items-center" data-id="element-80">
                <PhoneIcon size={18} className="mr-2 flex-shrink-0 text-[#95c11f]" data-id="element-81" />
                <span data-id="element-82">07014383978</span>
              </li>
              <li className="flex items-center" data-id="element-83">
                <MailIcon size={18} className="mr-2 flex-shrink-0 text-[#95c11f]" data-id="element-84" />
                <span data-id="element-85">info@socratesandrichards.com</span>
              </li>
            </ul>
          </div>
        </div>
        <div className="border-t border-gray-800 mt-10 pt-8 text-sm text-center" data-id="element-86">
          <p data-id="element-87">
            &copy; {currentYear} Socrates and Richard Company Ltd. All rights
            reserved.
          </p>
        </div>
      </div>
    </footer>;
};
export default Footer;